module.exports = __webpack_public_path__ + "static/media/Business deal-pana_green.4d732800.svg";